import React, { cloneElement, PropTypes } from 'react';

const PlanItem = ({ style, content, icon, iconStyle, title, backgroundColor }) => {
  const iconStyles = Object.assign({}, iconStyle, {
    display: 'block',
    color: 'rgb(255, 255, 255)',
    fill: 'rgb(255, 255, 255)',
    height: '76px',
    width: '38px',
    margin: '0 auto',
  });
  return (
    <li style={{ listStyle: 'none', display: 'inline-block', padding: '10px 25px', width: '50%', ...style }}>
      <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
        <span style={{
          backgroundColor: backgroundColor || 'rgb(255, 138, 11)',
          borderRadius: '50%',
          width: '76px',
          height: '76px',
          fontSize: '24px',
          color: 'white',
          display: 'inline-block',
          textAlign: 'center',
          lineHeight: '56px',
        }}
        >{cloneElement(icon, { style: iconStyles })}</span>
      </div>
      <div style={{ display: 'inline-block', marginLeft: '25px', width: '75%' }}>
        <h4 style={{ fontWeight: 300, margin: 0, padding: 0 }}>{title}</h4>
        <p>{content}</p>
      </div>
    </li>

  );
};

PlanItem.propTypes = {
  plan: PropTypes.object,
  companyType: PropTypes.string,
  onUpgradeClick: PropTypes.func,
};

export default PlanItem;



// WEBPACK FOOTER //
// ./src/app/components/upgrade/PlanItem.jsx